"use client";

import type { QRProps } from "@/contexts/QREditorContext/types";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";

export interface UseEmptyDataResult {
  isInitialPreview: boolean;
  data: any;
  defaultPreviewTitle: string;
}

export const useEmptyData = (
  props: QRProps<any> & { data?: { defaultPreviewTitle?: string } }
): UseEmptyDataResult => {
  const { data, isInitPreview: isInitialPreview } = usePreviewData(props);

  const defaultPreviewTitle =
    props.data?.defaultPreviewTitle || "Choose one of the options to begin";

  return {
    isInitialPreview,
    data,
    defaultPreviewTitle,
  };
};
